import React from 'react';
import Fuse from 'fuse.js';
import { throwNetworkError } from '@twnel/web-components';

import { RESET_VISUALBUILDER, TOGGLE_ELEMENT_INFO, UPLOADING_FILE_TO_S3 } from './constants';

export const resetVisualbuilder = () => ({
  type: RESET_VISUALBUILDER,
});

export const openPanel = (content) => ({
  type: TOGGLE_ELEMENT_INFO,
  payload: { showNodePanel: true, viewConnectionInfo: false, content },
});

export const closePanel = () => (dispatch) => {
  dispatch({
    type: TOGGLE_ELEMENT_INFO,
    payload: { showNodePanel: false },
  });
  setTimeout(
    () => dispatch({
      type: TOGGLE_ELEMENT_INFO,
      payload: { content: null },
    }), 250,
  );
};

export const toggleUploadinFile = (uploading) => ({
  type: UPLOADING_FILE_TO_S3,
  payload: { uploading },
});

export const useFuzzySearch = (items, searchKeys, callback) => React.useMemo(() => {
  const fuse = new Fuse(items, {
    includeScore: true,
    threshold: 0.2,
    keys: searchKeys,
  });
  return (query) => {
    if (!query) {
      callback(null);
      return items.map((item) => ({ item }));
    }

    const searchResults = fuse.search(query);
    if (searchResults.length >= 1 && searchResults[0].score < 0.001) {
      callback(searchResults[0].item);
    } else {
      callback(null);
    }
    return searchResults;
  };
}, [items, searchKeys, callback]);

export const uploadFile = ({ file, savingMedia }) => (
  dispatch, _getState, getContext,
) => {
  const { api } = getContext();
  dispatch(toggleUploadinFile(true));
  return api.companies.uploadFile(file)
    .then(({ url }) => {
      dispatch(toggleUploadinFile(false));
      if (savingMedia) savingMedia(url);
    })
    .catch((error) => throwNetworkError(error));
};
